import { HttpInterceptorFn } from '@angular/common/http';
import { API_BASE_PATH } from '@pool-league/frontend-shared-util-app-config';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

export function authInterceptor(): HttpInterceptorFn {
  return (req, next) => {
    const basePath = inject(API_BASE_PATH);
    const token = inject(OAuthService).getIdToken();
    if (req.url.startsWith(basePath) && token) {
      const header = 'Bearer ' + token;
      const headers = req.headers.set('Authorization', header);
      req = req.clone({ headers });
    }
    return next(req);
  };
}
